import React, { useEffect, useState } from 'react';
import { useTitle } from '../../../Hooks';
import { Spinner, Tables } from '../../../Components';
import { GetSmartProposalLogs } from '../../../Services/GeneratedProposals';
import { showError } from '../../../Helper';
import { ProposalLogsHeaderData } from './ProposalLogsHeaderData';
import './style.scss';
import { GeneratedProposalLogLocalePath } from './I18n/GeneratedProposalLogLocale';
import GeneratedProposalLogFilters from './GeneratedProposalLogFilters';

export default function GeneratedProposalLogView() {
  useTitle('GeneratedProposalLog');
  const [ProposalLogsData, setProposalLogsData] = useState({
    result: [],
    totalCount: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  const [filter, setFilter] = useState({
    proposalName: null,
    generatedBy: null,
    sharedToName: null,
    platformType: null,
    unitRefNumber: null,
    propertyName: null,
    createdDateFrom: null,
    createdDateTo: null,
    pageIndex: 1,
    pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
  });

  const getSmartProposalLogs = async () => {
    setIsLoading(true);
    try {
      const res = await GetSmartProposalLogs(filter);
      setProposalLogsData(res);
    } catch (error) {
      showError();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSmartProposalLogs();
  }, [filter]);
  return (
    <div className='view-wrapper'>
      <Spinner isActive={isLoading} />
      <div className='title-section p-2'>
        <div className='sub-title-properties-AML'>Generated Proposal Log</div>
      </div>
      <GeneratedProposalLogFilters
        filter={filter}
        setFilter={setFilter}
        ProposalLogsData={ProposalLogsData}
      />

      <div className='p-3 mt-3'>
        <Tables
          data={ProposalLogsData.result}
          headerData={ProposalLogsHeaderData}
          parentTranslationPath={GeneratedProposalLogLocalePath}
          itemsPerPage={filter.pageSize}
          activePage={filter.pageIndex - 1}
          totalItems={ProposalLogsData?.totalCount}
          onPageIndexChanged={(pageIndex) => {
            setFilter((prev) => ({
              ...prev,
              pageIndex: pageIndex + 1,
            }));
          }}
          onPageSizeChanged={(pageSize) => {
            setFilter((prev) => ({
              ...prev,
              pageSize,
            }));
          }}
          defaultActions={[]}
        />
      </div>
    </div>
  );
}
